/* eslint-disable complexity */
'use strict';

/* eslint-disable max-len */
window.RECOMENDACAO_STATUS = [
  { id: 'aberto', descricao: 'pendente', labelClassColor: 'label-warning', label: 'Pendente', color: 'warning' },
  { id: 'em_andamento', descricao: 'em_andamento', labelClassColor: 'label-warning', label: 'Em Andamento', color: 'warning' },
  { id: 'finalizado', descricao: 'aplicada', labelClassColor: 'label-success', label: 'Aplicada', color: 'success' },
  { id: 'finalizado_manualmente', descricao: 'finalizado manualmente', labelClassColor: 'label-success', label: 'Finalizado manualmente', color: 'success' }
];
/* eslint-enable */

window.RECOMENDACAO_ATRASADA = {
  id: false,
  descricao: 'atrasada',
  labelClassColor: 'label-danger',
  label: 'Atrasada',
  color: 'danger'
};

// eslint-disable-next-line max-lines-per-function, max-params
angular.module('webAgro1App').factory('RecomendacoesService', function($http, filterFilter, $q, $rootScope,
  RestService, ItensService, AplicacoesService, OperacoesService, RecomendacaoObjectService, PlantiosService,
  MessagesService, InformacoesCultivaresService, MIN_AREA_VALOR, DecimalsService) {
  const getIdsGruposInsumos = function(filters) {
    return !filters.gruposInsumos ? null : String(filters.gruposInsumos.map(function(object) {
      return object.id[1];
    }));
  };

  function getAqilaRecomendacao(id) {
    return $http.get(`${SERVER }v1/aqila_recomendacoes/${ id}`);
  }

  function getTotalTanque(produto, consumoPorHectare, capacidadeTanqueInalterada) {
    const doseTanqueOriginal = Number(produto.qt_dose_tanque) || 0;
    if (capacidadeTanqueInalterada && doseTanqueOriginal > 0) {
      return doseTanqueOriginal;
    }

    const totalTanqueCalculado = consumoPorHectare * produto.dose;
    if (DecimalsService.isDecimalV2Enabled()) {
      return DecimalsService.truncateDoseOrQuantity(
        DecimalsService.roundForCalculation(totalTanqueCalculado, DecimalsService.DECIMAL_PLACES_CALCULATION)
      ) || 0;
    }

    return Number(totalTanqueCalculado.toFixed(4)) || 0;
  }

  return {
    getRecomendacaoStatus: function(id) {
      return filterFilter(RECOMENDACAO_STATUS, { id: id }, true)[0] || {};
    },

    // TODO: rever complexity
    // eslint-disable-next-line complexity
    list: function(filters) {
      const params = !filters ? {} : {
        data_inicial: filters.dataInicial || null,
        data_final: filters.dataFinal || null,
        page: filters.page || null,
        gleba: (filters.gleba || {}).id || null,
        atividade: (filters.atividade || {}).id || null,
        recomendante: (filters.recomendante || {}).id || null,
        grupos_insumos: getIdsGruposInsumos(filters) || (filters.grupoInsumo ? [filters.grupoInsumo.id[1]] : null),
        status: (filters.status || {}).id,
        eliminado: 'N'
      };

      return RestService.getFromUrl(`${SERVER + API_VERSION }recomendacoes/simple`, params);
    },

    // TODO: rever complexity
    // eslint-disable-next-line complexity
    listCorrecoes: function(filters) {
      const params = !filters ? {} : {
        data_inicial: filters.dataInicial || null,
        data_final: filters.dataFinal || null,
        page: filters.page || null,
        gleba: (filters.gleba || {}).id || null,
        atividade: (filters.atividade || {}).id || null,
        recomendante: (filters.recomendante || {}).id || null,
        grupos_insumos: getIdsGruposInsumos(filters),
        status: (filters.status || {}).id,
        eliminados: 'N',
        operacao: ($rootScope.parametros.operacao_correcao_solo || {}).id
      };

      return RestService.getFromUrl(`${SERVER }v1/aqila_recomendacoes`, params);
    },

    // TODO: rever complexity
    // eslint-disable-next-line complexity
    listAdubacoes: function(filters) {
      const params = !filters ? {} : {
        data_inicial: filters.dataInicial || null,
        data_final: filters.dataFinal || null,
        page: filters.page || null,
        gleba: (filters.gleba || {}).id || null,
        atividade: (filters.atividade || {}).id || null,
        recomendante: (filters.recomendante || {}).id || null,
        grupos_insumos: getIdsGruposInsumos(filters),
        status: (filters.status || {}).id,
        eliminados: 'N',
        operacao: ($rootScope.parametros.operacao_adubacao || {}).id
      };

      return RestService.getFromUrl(`${SERVER }v1/aqila_recomendacoes`, params);
    },

    get: function(id) {
      return $http.get(`${SERVER + API_VERSION }recomendacoes/${ id}`);
    },

    getAqilaRecomendacao: function(id) {
      return getAqilaRecomendacao(id);
    },

    getCorrecao: function(id) {
      return getAqilaRecomendacao(id);
    },

    getAdubacao: function(id) {
      return getAqilaRecomendacao(id);
    },

    getSemeadura: function(id) {
      return $http.get(`${SERVER }v2/recomendacoes_semeadura/${ id}`);
    },

    getRecomendacaoAplicacao: function(params) {
      let method = this.get;
      switch (params.operacao) {
      case 'operacao_semeadura':
        method = this.getSemeadura;
        break;
      case 'operacao_adubacao':
        method = this.getAdubacao;
        break;
      case 'operacao_correcao_solo':
        method = this.getCorrecao;
        break;
      }
      return method(params.id);
    },

    getPlantios: function(params) {
      return PlantiosService.getPlantioSimples({
        onlyActive: true,
        safra: params.safra,
        atividade: params.atividade,
        gleba: params.gleba
      }).catch(function(error) {
        console.error('Erro ao buscar plantios', error);
        MessagesService.alert('Erro ao carregar plantios');
      });
    },

    getInformacaoCultivar: function(params) {
      const deferred = $q.defer();
      const informacoesCultivar = InformacoesCultivaresService.get({
        safra: params.safra,
        atividade: params.atividade,
        gleba: params.gleba
      }).catch(function(error) {
        console.error('Erro ao buscar informações da cultivar', error);
        MessagesService.alert('Erro ao carregar informações da cultivar');
      });
      deferred.resolve(Object.values(informacoesCultivar));
      return informacoesCultivar;
    },

    getInformacoesGleba: async function(params) {
      const plantios = await this.getPlantios(params).then(({ data }) => (data));
      const infoCultivar = await this.getInformacaoCultivar(params).then(({ data }) => (data));

      // eslint-disable-next-line complexity
      return plantios.map((plantio) => {
        const infoCultivarFiltered = _.find(infoCultivar, { cd_insumo: plantio.insumo_id });
        return {
          cultivar: plantio.insumo.descricao || null,
          data_inicio_plantio: plantio.data_inicio || null,
          data_fim_plantio: plantio.data_fim || null,
          data_estimada_colheita: (infoCultivarFiltered || {}).data_estimada_colheita,
          data_emergencia: (infoCultivarFiltered || {}).data_emergencia,
          dias_ciclo: (infoCultivarFiltered || {}).data_emergencia ?
            Math.max(moment().diff(infoCultivarFiltered.data_emergencia, 'days'), 0) : null
        };
      });
    },

    listItemsBalance: function(filters) {
      return ItensService.listItemsBalance(filters);
    },

    listGlebasAtividades: function(filters, propriedade) {
      const deferred = $q.defer();
      const _this = this;

      AplicacoesService.listSeedings(filters).then(function(data) {
        const ids = (data.data || []).map(function(gleba) {
          return gleba.cd_gleba;
        }).filter(function(value, index, array) {
          return array.indexOf(value) === index;
        });
        deferred.resolve(_this.listGlebas(ids, (propriedade || {}).glebas, data.data));
      }, deferred.reject);

      return deferred.promise;
    },

    // eslint-disable-next-line max-lines-per-function
    listAtividadesPeriodo: function(filters) {
      const deferred = $q.defer();

      filters = (filters || {});

      filters.dont_group_by_insumo = true;

      const propriedade = filters.propriedade ? filters.propriedade : $rootScope.currentPropriedade.id;

      AplicacoesService.listSeedings(filters).then(function(data) {
        // eslint-disable-next-line max-len
        const dataFilteredByPropriedade = _.filter((data.data || []), { cd_propriedade: propriedade });

        const seedings = _.sortBy(dataFilteredByPropriedade, ['cd_atividade', 'cd_empreend']);

        const atividades = seedings
        // eslint-disable-next-line no-confusing-arrow
          .filter((seeding) => !filters.safra ? true : seeding.cd_safra === filters.safra)
          .reduce(function(result, record) {
            result[record.cd_atividade] = result[record.cd_atividade] || {
              id: record.cd_atividade,
              descricao: record.descricao_atividade,
              safra: record.cd_safra,
              glebas: [],
              empreendimentoGleba: {},
              relacaoCampo: {}
            };
            result[record.cd_atividade].glebas.push(record.cd_gleba);
            const areaEmpreendimento = Number(record.area_empreendimento);
            const areaRelacaoCampo = Number(record.area_aplicada);
            const empreendimentoGleba = result[record.cd_atividade].empreendimentoGleba[record.cd_gleba] || 0;
            const relacaoCampo = result[record.cd_atividade].relacaoCampo[record.cd_gleba] || 0;
            if (record.relacao_campo_id) {
              result[record.cd_atividade].relacaoCampo[record.cd_gleba] = relacaoCampo + areaRelacaoCampo;
            }
            result[record.cd_atividade].empreendimentoGleba[record.cd_gleba] = empreendimentoGleba + areaEmpreendimento;

            return result;
          }, {});
        deferred.resolve(Object.values(atividades));
      }, deferred.reject);

      return deferred.promise;
    },

    getValuesDefault: function(recomendacao) {
      const deferred = $q.defer();
      const url = `${SERVER + API_VERSION }recomendacoes/ultimo_registro`;

      $http.get(url).then(function(data) {
        if (data.data !== null && Object.keys(data.data).length > 0) {
          const result = data.data;

          if (result.responsavel && result.responsavel.id) {
            recomendacao.responsavel = result.responsavel;
          }

          recomendacao.vazao = Number(result.vazao) || 0;
          recomendacao.taxaRemonte = Number(result.taxa_remonte) || 0;
        }
        recomendacao.operacao = $rootScope.parametros.operacao_correcao_solo.id;
        deferred.resolve(recomendacao);
      }, deferred.reject);

      return deferred.promise;
    },


    listGlebas: function(ids, propriedadeGlebas, data) {
      let glebas = (propriedadeGlebas || $rootScope.currentPropriedade.glebas || []);
      let empreendimento;

      //TODO REVER
      // eslint-disable-next-line array-callback-return
      glebas = [...glebas].map(function(gleba) {
        if (ids.indexOf(gleba.id) >= 0) {
          //TODO REVER ISSO
          if (data) {
            empreendimento = data.find((g) => g.cd_gleba === gleba.id).cd_empreend;
          }
          gleba.area_total = Number(gleba.area_total);
          gleba.area = gleba.area_total;
          gleba.selected = false;
          gleba.coordinates = null;
          gleba.empreendimento = empreendimento;
          return gleba;
        }
      });

      return glebas.filter(Boolean);
    },

    getPulverizacaoGleba: function(filters) {
      return OperacoesService.getSpraysHistory(filters);
    },

    delete: function(id) {
      return $http.delete(`${SERVER + API_VERSION }recomendacoes/${ id}`);
    },

    deleteCorrecao: function(id) {
      return $http.delete(`${SERVER }v1/aqila_recomendacoes/${ id}`);
    },

    deleteAdubacao: function(id) {
      return $http.delete(`${SERVER }v1/aqila_recomendacoes/${ id}`);
    },

    save: function(recomendacao) {
      const result = RecomendacaoObjectService.convertToSend(recomendacao);
      return $http({
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        url: `${SERVER + API_VERSION }recomendacoes`,
        data: { recomendacoes: [result] }
      });
    },

    saveCorrecao: function(recomendacao) {
      const result = RecomendacaoObjectService.convertToSendCorrecao(recomendacao);
      return $http({
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        url: `${SERVER }v1/aqila_recomendacoes`,
        data: { recomendacoes: [result] }
      });
    },

    saveAdubacao: function(recomendacao) {
      const result = RecomendacaoObjectService.convertToSendAdubacao(recomendacao);
      return $http({
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        url: `${SERVER }v1/aqila_recomendacoes`,
        data: { recomendacoes: [result] }
      });
    },

    update: function(recomendacao) {
      recomendacao = RecomendacaoObjectService.convertToSend(recomendacao);
      //TODO REVER
      // eslint-disable-next-line max-len
      return $http.patch(`${SERVER + API_VERSION }recomendacoes/${recomendacao.id}.json`, { recomendacao: recomendacao });
    },

    updateCorrecao: function(recomendacao) {
      recomendacao = RecomendacaoObjectService.convertToSendCorrecao(recomendacao);
      return $http.patch(`${SERVER }v1/aqila_recomendacoes/${recomendacao.id}.json`, { recomendacao: recomendacao });
    },

    updateAdubacao: function(recomendacao) {
      recomendacao = RecomendacaoObjectService.convertToSendAdubacao(recomendacao);
      return $http.patch(`${SERVER }v1/aqila_recomendacoes/${recomendacao.id}.json`, { recomendacao: recomendacao });
    },

    aprove: function(recomendacao) {
      const payload = {
        recomendacao: {
          id: recomendacao.id,
          propriedade: recomendacao.propriedade.id,
          situacao: 'aprovado'
        }
      };

      return $http.patch(`${SERVER }v1/recomendacoes/${ recomendacao.id }.json`, payload);
    },

    aproveAqilaRecomendation: function(recomendacao) {
      return $http.patch(`${SERVER }v1/aqila_recomendacoes/${ recomendacao.id }/aprovar`);
    },

    rejectAqilaRecomendation: function(recomendacao) {
      const payload = {
        motivo_rejeicao: recomendacao.motivo_rejeicao
      };

      return $http.patch(`${SERVER }v1/aqila_recomendacoes/${ recomendacao.id }/rejeitar`, payload);
    },

    finalizar: function(endpoint, recomendacao) {
      return $http({
        method: 'PUT',
        url: `${SERVER}${API_VERSION}${endpoint}/${recomendacao.id}/finalizar/`
      });
    },

    reject: function(recomendacao) {
      const payload = {
        recomendacao: {
          id: recomendacao.id,
          propriedade: recomendacao.propriedade.id,
          situacao: 'rejeitado',
          motivo_rejeicao: recomendacao.motivo_rejeicao
        }
      };

      return $http.patch(`${SERVER }v1/recomendacoes/${ recomendacao.id }.json`, payload);
    },

    // TODO: rever complexity
    // eslint-disable-next-line complexity
    calculateCapacity: function(recomendacao) {
      if (recomendacao) {
        const temVazao = recomendacao.vazao && recomendacao.vazao > 0;
        const temCapacidadeTanque = recomendacao.capacidadeTanque > 0;

        const capacidadeTanqueOriginal = Number(recomendacao.capacidade_tanque) || 0;
        const capacidadeTanqueInalterada = Number(recomendacao.capacidadeTanque) === capacidadeTanqueOriginal;

        for (let index = recomendacao.insumos.length-1; index >=0; index--) {
          const produto = recomendacao.insumos[index];
          const consumoPorHectare = temVazao ? recomendacao.capacidadeTanque / recomendacao.vazao : 0;

          produto.capacidade = {
            totalTanque: getTotalTanque(produto, consumoPorHectare, capacidadeTanqueInalterada),
            abreviatura: produto.unidade.abreviatura || ''
          };
        }

        recomendacao.totalAbastecidas = 0;
        recomendacao.areaTotal = 0;
        for (let indice = recomendacao.glebas.length-1; indice >= 0; indice--) {
          const gleba = recomendacao.glebas[indice];
          const valor = (gleba.area_total / (recomendacao.capacidadeTanque / recomendacao.vazao));
          gleba.numeroAbastecidas = (!temVazao || !temCapacidadeTanque) ? 0 : valor;
          recomendacao.totalAbastecidas += gleba.numeroAbastecidas;
          recomendacao.areaTotal += parseFloat(gleba.area_total);
        }
      }

      return recomendacao;
    },

    validateGlebas($scope) {
      const invalidGlebas = $scope.glebasAtividade.filter(function(gleba) {
        return gleba.area < MIN_AREA_VALOR && gleba.selected;
      });

      if (invalidGlebas.length) {
        return { valid: false, message: `A área recomendada deve ser maior ou igual a ${MIN_AREA_VALOR}.` };
      }

      $scope.changeGlebasSelected();
      const valid = $scope.recommendation.glebas && +$scope.recommendation.glebas.areaTotal > 0;
      return { valid: valid, message: 'Informe um talhão válido.' };
    },

    // TODO: rever complexity
    // eslint-disable-next-line complexity
    routeUpdateFunction($scope, $routeParams) {
      if (!$routeParams.activeRecommendation) {
        ($scope.recommendations || []).filter(function(rec) {
          return rec.open;
        }).forEach(function(rec) {
          $scope.openRecommendationDetail(null, rec);
        });
      }
      if ($routeParams.recommendationFilters) {
        const filters = JSON.parse($routeParams.recommendationFilters);
        if ($routeParams.historyDate && $routeParams.historyDate !== filters.dataInicial) {
          const date = moment($routeParams.historyDate).format('DD/MM/Y');
          $scope.setPeriodo({
            dataInicial: $routeParams.historyDate,
            dataFinal: $routeParams.historyDate,
            descricao: `${date} à ${date}`
          });
        }

        if (+$routeParams.activeGleba && +$routeParams.activeGleba !== filters.gleba) {
          $scope.setGleba($scope.$root.currentPropriedade.glebas.find((g) => g.id === +$routeParams.activeGleba));
        }
      }
    }
  };
});
